import { render } from "./KurulumHapi.vue?vue&type=template&id=22b7f0b5"
import script from "./KurulumHapi.vue?vue&type=script&lang=js"
export * from "./KurulumHapi.vue?vue&type=script&lang=js"

import "./KurulumHapi.vue?vue&type=style&index=0&id=22b7f0b5&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__